module.exports = __webpack_public_path__ + "img/Light Focus01.a702e432.png";